// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1_gv-","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3kl_f","obliqueLine":"membershipbadge_obliqueLine__1k2B-"};